import { Box } from "@chakra-ui/react"

export const TestPage = (props) => {
    return (
        <Box bg='gray.200' h='200px'>

        </Box>
    )
}